import axios from "axios";
import AuthenticationFailureHandler from "../../utils/AuthenticationFailureHandler";
import { getHeaders } from "../../utils/AuthorizationUtil";
import { BASE_URL } from "../../utils/EmpUtil";
import { is401 } from "../../errors/ErrorConstants";

export default class OrderNotificationsClient {
  static baseUrl = BASE_URL;

  static getDealerOrderNotifications(user) {
    const url = `${
      this.baseUrl
    }/dealer/getUpdateNotifications?dealerCommonIds=${user.getCommonIdsWithSDLR()}`;

    return axios
      .get(url, getHeaders(user.token))
      .then((response) => response.data)
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }

        return Promise.reject(error);
      });
  }

  static getLatestOrderUpdateNotifications(user, orderId) {
    const url = `${this.baseUrl}/dealer/getLatestOrderUpdateNotifications?orderId=${orderId}`;

    return axios
      .get(url, getHeaders(user.token))
      .then((response) => response)
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static markNotificationStatusRead(user, id) {
    const url = `${this.baseUrl}/dealer/read/notifications/${id}`;

    return axios
      .post(url, "", getHeaders(user.token))
      .then((response) => response.data)
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }

        return Promise.reject(error);
      });
  }

  static deleteNotification(user, id) {
    const url = `${this.baseUrl}/dealer/delete/notifications/${id}`;

    return axios
      .delete(url, getHeaders(user.token))
      .then((response) => response.data)
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }

        return Promise.reject(error);
      });
  }
}
